import { FC, useState, useEffect, Fragment } from 'react';
import dayjs, { Dayjs } from 'dayjs';
// Utilities
import { buildUserName } from 'utilities/Utilities';
// 
import GroupPrizes from './GroupPrizes';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  quizzes: any[];
  results: any;
  prizes: any;
};

let now = dayjs();

const TextCountdown:FC<Props> = ({
  // Props
  quizzes, prizes, results
}) => {
  const { t } = useTranslation('common');

  const [ end, setEnd ] = useState(false);
  const [ message, setMessage ] = useState<string | null>(null);

  useEffect(() => {
    console.log(quizzes);

    const sortedQuizzes = [...quizzes].sort((a:any, b:any) => new Date(Number(a.startsDate)).getTime() - new Date(Number(b.startsDate)).getTime());

    const { endTime } = quizzes.reduce((acc:any, cur:any) => {
      const start = Number(cur.startsDate);
      const end = Number(cur.endsDate);
      acc['startTime'] = !acc.startTime ? start : start < acc.startTime ? start : acc.startTime;
      acc['endTime'] = !acc.endTime ? end : end > acc.endTime ? end : acc.endTime;
      return acc;
      // eslint-disable-next-line
    }, {});

    // const startDate = dayjs(startTime);
    const endDate = dayjs(endTime);

    if ( now.isAfter(endDate) ) setEnd(true);

    let nextTime:Dayjs | null = null;

    for ( let quiz of sortedQuizzes ){
      const quizStartDate = dayjs(Number(quiz.startsDate));
      if ( now.isBefore(quizStartDate) ){
        nextTime = quizStartDate;
        break;
      }
    }

    if ( nextTime ){
      setMessage(t('quiz.quizGroupPage.nextQuizStartsAt', { date: dayjs(nextTime).format('MMMM D, YYYY') }))
    } else {
      const sortedEndDates = sortedQuizzes.map(q => q.endsDate).map(Number).sort((a:number, b:number) => a - b);
      setMessage(t('quiz.quizGroupPage.winnersWillBeAnnouncedOn', { date: dayjs(Number(sortedEndDates[sortedEndDates.length - 1])).format('MMMM D, YYYY') }))
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      {!end ? (
        <Fragment>
          <div className="text-center text-sm mb-4">{message}</div>
          <GroupPrizes prizes={prizes} />
        </Fragment>
      ) : (
        <Fragment>
          {results.length ? (
            <div className="shadow-neu-content-inner rounded-lg p-2">
              <ul className="rounded">
                {results.map((result:any, index:number) => (
                  <li
                    key={`leaderboard-item-${index}`}
                    className="flex py-2 px-3 border-b border-gray-100 last:border-none"
                  >
                    <div className="flex-1 flex items-center">
                      <span className="font-bold mr-2">{index + 1}.</span>
                      {buildUserName(result)}
                    </div>
                    <div className="font-bold">{result.score}</div>
                  </li>
                ))}
              </ul>
            </div>
          ) : null}
        </Fragment>
      )}
    </Fragment>
  )
}

export default TextCountdown;
